import { config } from '@services/config';
import { IBrokerage } from '@services/brokerage';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useBrokerageById = (isEnabled: boolean, brokerageId: string | null = '') => {
  const client = useClient();
  const result = useQuery<IBrokerage, Error>({
    queryKey: userQueryKey.userBrokerage,
    queryFn: async () => client.get(`brokerage/${brokerageId}`).json<IBrokerage>(),
    enabled: isEnabled,
    ...config,
  });
  return { ...result, userBrokerage: result.data };
};

// TODO do we need this? whats difference between here and getBrokerage?
